<template>
  <div class="toggle-switch flex flex-1 justify-between gap-2.5">
    <div
      v-if="label"
      class="label-wrapper flex items-center text-text">
      <slot name="label">{{ label }}</slot>
    </div>
    <div
      class="toggle-border cursor-pointer rounded-full p-0"
      :class="small ? 'h-4 w-7' : 'h-6 w-11'"
      @click="reverseState">
      <div
        class="toggle flex h-full w-full items-center rounded-full transition-colors duration-200"
        :class="state ? 'active bg-accent' : 'bg-input'">
        <div
          class="slider-border flex items-center rounded-full
                 shadow-[2px_2px_7px_var(--shadow-color)] transition-all duration-[400ms]"
          :class="[
            small ? 'mx-0.5 size-3' : 'mx-1 size-4',
            state && (small ? 'on translate-x-3' : 'on translate-x-5'),
          ]">
          <div
            class="slider size-full rounded-full transition-colors duration-200"
            :class="state ? 'bg-text' : 'bg-text-muted'"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';

const props = defineProps({
  label: String,
  modelValue: Boolean,
  small: Boolean,
});

const emit = defineEmits(['update:modelValue']);

const state = ref(props.modelValue !== null ? props.modelValue : false);

const reverseState = () => {
  state.value = !state.value;
  emit('update:modelValue', state.value);
};

watch(() => props.modelValue, () => {
  state.value = props.modelValue;
});
</script>
